


const VideoBox = (): JSX.Element => {

	return (
		<div className='video-box'>

			<div className='video-wrapper'>
				<iframe
					src="https://www.youtube-nocookie.com/embed/GBa3HJ8ZkN0"
					title="VETlímce video - Pes"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowFullScreen />
			</div>

			<h2>Oproti klasickým plastovým límcům mají VETlímce řadu výhod a&nbsp;psům tak přinášejí nejen fyzický, ale&nbsp;i&nbsp;psychický komfort:</h2>

			<ul>
				<li>nebrání v&nbsp;prostorové orientaci</li>
				<li>zjednodušují průchod terénem i&nbsp;obydlím</li>
				<li>umožňují bezproblémové krmení</li>
				<li>zajišťují klidný spánek</li>
				<li>nedráždí pokožku</li>
				<li>snižují riziko zapařenin</li>
				<li>snižují stres a&nbsp;mohou tak přispět k&nbsp;hojení</li>
			</ul>
		
		</div>
	);
};

export default VideoBox;